import DocCard from "./DocCard";

export default DocCard;
